import AddressInputContainer from "../../containers/AddressInputContainer";

export default function AddressInputPage () {
    
    return (
        <>
            <AddressInputContainer></AddressInputContainer>
        </>
    )
}